// extracted by mini-css-extract-plugin
export default {"box":"couponFilterPage_box__AEtY4","box__content":"couponFilterPage_box__content__EH41g","box__btn":"couponFilterPage_box__btn__VhijI"};